export default __webpack_public_path__ + "static/media/training-illustration4.280dfeb6.svg";